<script lang="ts" setup>
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import RoomieButtonLink from '@lahaus-roomie/roomie/src/components/RoomieButtonLink/index.vue'
import type { Option, Props } from './types'

withDefaults(defineProps<Props>(), {
  dataAttributes: {
    dataLh: {
      P: 'unknown',
      Z: 'unknown',
      A: 'unknown'
    }
  }
})
const { t, rt, tm } = useI18n()
const { $useLhId } = useNuxtApp()
const emit = defineEmits(['submit', 'skip'])

const options = tm('options') as Array<Option>

const handleOptionClick = (value: string) => {
  emit('submit', { name: 'deliveryTerm', value: value || null })
}

const handleSkip = () => {
  emit('skip', { name: 'deliveryTerm', value: null })
}
</script>

<script lang="ts">
export default {
  name: 'OnboardingStepsDeliveryTerm'
}
</script>

<template>
  <section class="onboarding-steps-delivery-term">
    <h2 class="hl-1-sb mb-24 !text-20 md:!text-24 text-pine-600 text-center">
      {{ t('title') }}
    </h2>

    <div class="onboarding-steps-delivery-term__options-holder">
      <RoomieButton
        v-for="(option, index) in options"
        :id="`delivery-term-option-${index}`"
        :key="`delivery-term-option-${index}`"
        :data-lh-id="$useLhId({ ...dataAttributes.dataLh, C: rt(option.label), I: index })"
        variant="primary"
        @click="() => handleOptionClick(rt(option.value))">
        {{ rt(option.label) }}
      </RoomieButton>
    </div>

    <div class="w-full mt-24 flex justify-center">
      <RoomieButtonLink
        id="onboarding-steps-delivery-term-skip-button"
        :data-lh-id="$useLhId({ ...dataAttributes.dataLh, C: t('skipCta') })"
        type="button"
        :aria-label="t('skipCta')"
        variant="ghost"
        @click="handleSkip">
        {{ t('skipCta') }}
      </RoomieButtonLink>
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
